<template>
  <div class="flex flex-col items-center justify-center w-full bg-[#F2F6FA]">
    <section class="flex flex-col items-center w-full justify-center">
      <div
        class="flex items-center justify-start md:mt-5 mb-2 md:mb-0 mt-2 px-2 md:px-0 w-full"
      >
        <div class="items-center gap-2 px-4 mt-5 -ml-2 d-flex">
          <img
            src="../../assets/img/sidebar/post.svg"
            class="cursor-pointer w-6 md:w-[28px]"
            alt="post"
          />
          <div class="flex items-center gap-1">
            <p class="text-base md:text-[22px] font-bold">
              Posts <span class="md:hidden">></span>
            </p>
            <p class="text-[#8056DE] text-sm font-semibold md:hidden">
              &nbsp;{{ selectedTabName }}
            </p>
          </div>
        </div>
      </div>
      <div class="w-full pb-[33px] mt-5 bg-white md:rounded-3xl">
        <div class="md:py-[4px] flex gap-4 font-semibold w-full">
          <v-tabs v-model="tab" @change="resetLoader">
            <!-- <v-tab value="0">
              <img :src="require('@/assets/img/global-icons/dashboard.svg')" alt="dashboard" class="w-[20px] h-[20px] " />
              <img :src="require('@/assets/img/global-icons/dashboardwhite.svg')" alt="dashboard" class="w-[20px] h-[20px] " />
              Dashboard
            </v-tab> -->
            <v-tab value="0">
              <img
                :src="require('@/assets/img/post-icons/gallerygray.svg')"
                alt="delete"
                class="w-[20px] h-[20px]"
              />
              <img
                :src="require('@/assets/img/post-icons/gallerywhite.svg')"
                alt="delete"
                class="w-[20px] h-[20px]"
              />
              Published
            </v-tab>
            <v-tab value="1">
              <img
                :src="require('@/assets/img/post-icons/calendergray.svg')"
                alt="delete"
                class="w-[20px] h-[20px]"
              />
              <img
                :src="require('@/assets/img/post-icons/calenderwhite.svg')"
                alt="delete"
                class="w-[20px] h-[20px]"
              />
              Scheduled
            </v-tab>
            <v-tab value="2">
              <img
                :src="require('@/assets/img/post-icons/draftgray.svg')"
                alt="delete"
                class="w-[20px] h-[20px]"
              />
              <img
                :src="require('@/assets/img/post-icons/draftwhite.svg')"
                alt="delete"
                class="w-[20px] h-[20px]"
              />
              Drafts
            </v-tab>
            <v-tab value="3">
              <img
                :src="require('@/assets/img/gallery-icons/delete.svg')"
                alt="delete"
                class="w-[20px] h-[20px]"
              />
              <img
                :src="require('@/assets/img/post-icons/deletewhite.svg')"
                alt="delete"
                class="w-[20px] h-[20px]"
              />
              Deleted
            </v-tab>
          </v-tabs>
        </div>

        <!-- Dashboard Content -->
        <!-- <div v-if="tab == 0" class="bg-[#F2F6FA] pb-2 pt-2 md:pt-[33px] px-2 lg:px-5 md:rounded-3xl">
          <div class="flex justify-end mb-4">
            <v-btn color="#8056DE" text @click="refreshDashboardStats" class="text-white px-4">
              <v-icon left>mdi-refresh</v-icon>
              Refresh
            </v-btn>
          </div> -->

        <!-- <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 mb-6">
            <div class="bg-white p-4 rounded-xl shadow-sm">
              <h3 class="text-gray-600 text-sm mb-1">Published Posts</h3>
              <div class="flex items-center">
                <div class="text-2xl font-bold">{{ dashboardStats.publishedCount || 0 }}</div>
                <v-icon color="#8056DE" class="ml-auto">mdi-file-document-outline</v-icon>
              </div>
            </div>
             -->
        <!-- Scheduled Posts -->
        <!-- <div class="bg-white p-4 rounded-xl shadow-sm">
              <h3 class="text-gray-600 text-sm mb-1">Scheduled Posts</h3>
              <div class="flex items-center">
                <div class="text-2xl font-bold">{{ dashboardStats.scheduledCount || 0 }}</div>
                <v-icon color="#8056DE" class="ml-auto">mdi-calendar-clock</v-icon>
              </div>
            </div> -->

        <!-- Draft Posts -->
        <!-- <div class="bg-white p-4 rounded-xl shadow-sm">
              <h3 class="text-gray-600 text-sm mb-1">Draft Posts</h3>
              <div class="flex items-center">
                <div class="text-2xl font-bold">{{ dashboardStats.draftCount || 0 }}</div>
                <v-icon color="#8056DE" class="ml-auto">mdi-file-outline</v-icon>
              </div>
            </div> -->

        <!-- Total Posts -->
        <!-- <div class="bg-white p-4 rounded-xl shadow-sm">
              <h3 class="text-gray-600 text-sm mb-1">Total Posts</h3>
              <div class="flex items-center">
                <div class="text-2xl font-bold">{{ dashboardStats.totalCount || 0 }}</div>
                <v-icon color="#8056DE" class="ml-auto">mdi-file-multiple-outline</v-icon>
              </div>
            </div>
          </div> -->

        <!-- Platform Distribution Chart -->
        <!-- <div class="bg-white p-4 rounded-xl shadow-sm mb-6">
            <h3 class="text-lg font-semibold mb-4">Posts by Platform</h3>
            <div class="h-64">
              <canvas ref="platformChart" height="250"></canvas>
              <div v-if="!hasPlatformData" class="flex justify-center items-center h-full">
                <p class="text-gray-500">No platform data available</p>
              </div>
            </div>
          </div> -->

        <!-- Monthly Posts Chart -->
        <!-- <div class="bg-white p-4 rounded-xl shadow-sm">
            <h3 class="text-lg font-semibold mb-4">Posts by Month</h3>
            <div class="h-64">
              <canvas ref="monthlyChart" height="250"></canvas>
              <div v-if="!hasMonthlyData" class="flex justify-center items-center h-full">
                <p class="text-gray-500">No monthly data available</p>
              </div>
            </div>
          </div>
          
          <p class="text-xs text-gray-500 mt-4 text-right">
            Last updated: {{ lastUpdated ? formatDate(lastUpdated) : 'Never' }}
          </p>
        </div> -->

        <!-- Other tabs content -->
        <div
          class="bg-[#F2F6FA] pb-2 pt-2 md:pt-[33px] px-2 lg:px-5 md:rounded-3xl"
        >
          <div class="grid grid-cols-1 gap-4 md:grid-cols-2 posts">
            <post-card
              v-for="(post, i) in posts"
              :tab="tab"
              :post="post"
              :key="i"
              @onPostDelete="onPostDelete(i)"
              @onSocialPostDelete="onSocialPostDelete()"
            ></post-card>
          </div>
          <infinite-loading ref="loader" @infinite="fetchPosts">
            <div slot="spinner">
              <v-skeleton-loader
                class="mx-auto"
                type="image,article"
              ></v-skeleton-loader>
            </div>
            <div slot="no-results"></div>
          </infinite-loading>
          <template v-if="!isLoading && posts.length == 0">
            <div class="text-center py-2">
              <h4 class="text-xl font-bold">No posts to display</h4>
            </div>
          </template>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import InfiniteLoading from "vue-infinite-loading";
import { auth, platforms } from "@/utils/firebase.utils.js";
import {
  collection,
  getDocs,
  limit,
  orderBy,
  query,
  startAfter,
  where,
  getCountFromServer,
} from "firebase/firestore";
import { colUsers } from "@/utils/firebase.utils";
import moment from "moment";
import PostCard from "@/components/post/PostCard.vue";
import { getDate } from "@/utils/common.utils";
import Chart from "chart.js/auto";

export default {
  components: {
    PostCard,
    InfiniteLoading,
  },
  data() {
    return {
      showDialog: false,
      socialAppLists: [],
      outputIds: [],
      posts: [],
      isLoading: false,
      searchEnable: false,
      search: "",
      tab: 0,
      startAfter: null,
      allPlatforms: [],
      dashboardStats: {
        publishedCount: 0,
        scheduledCount: 0,
        draftCount: 0,
        deletedCount: 0,
        totalCount: 0,
        platformDistribution: {},
        monthlyPosts: {},
      },
      lastUpdated: null,
      platformChart: null,
      monthlyChart: null,
      cacheExpiry: 24 * 60 * 60 * 1000, // 24 hours in milliseconds
      isLoadingStats: false,
      hasPlatformData: false,
      hasMonthlyData: false,
    };
  },
  computed: {
    selectedTabName() {
      switch (this.tab) {
        case 0:
          return "Published";
        case 1:
          return "Scheduled";
        case 2:
          return "Drafts";
        case 3:
          return "Deleted";
      }
      return "";
    },
  },
  watch: {
    currentUID() {
      this.resetLoader();
      if (this.tab === 0) {
        this.fetchDashboardStats();
      }
    },
    WID() {
      this.resetLoader();
      if (this.tab === 0) {
        this.fetchDashboardStats();
      }
    },
    tab(newVal) {
      if (newVal === 0) {
        this.fetchDashboardStats();
      }
    },
  },
  methods: {
    onPostDelete(i) {
      this.posts.splice(i, 1);
    },
    onSocialPostDelete() {
      this.resetLoader();
    },
    resetLoader() {
      this.startAfter = null;
      this.posts = [];
      if (this.$refs.loader) {
        this.$refs.loader.stateChanger.reset();
      }
    },
    handleCreatePost() {
      if (this.authUser.fly_credits > 0) {
        this.$router.replace("/create-post");
      } else {
        this.showDialog = true;
      }
    },
    closeDialog() {
      this.showDialog = false;
    },
    renewSubscription() {
      this.$router.push("/subscription");
      this.closeDialog();
    },
    openNewPostDialog() {
      // Add logic to open a new post dialog or perform any other action
      console.log("Opening new post dialog...");
    },
    async fetchPosts($state) {
      const vm = this;
      let currentUID = this.currentUID || vm.uid;
      if (!vm.currentUID && !vm.WID) return;
      try {
        vm.isLoading = true;
        let col = collection(
          colUsers,
          currentUID,
          "fly_workspaces",
          vm.WID,
          "social-posts"
        );
        let queries = [];
        console.log("tab", vm.tab);

        // Fetch posts for the "Published" tab
        if (vm.tab == 0) {
          queries = [
            orderBy("created_at", "desc"),
            where("post_status", "==", "published"),
          ];
        }

        // Fetch posts for the "Scheduled" tab
        if (vm.tab == 1) {
          let currentDate = this.getCurrentDate();
          queries.push(
            orderBy("scheduled_at", "asc"),
            where("scheduled_at", ">", currentDate),
            where("when_to_post", "==", "schedule")
          );
        }

        // Fetch posts for the "Drafts" tab
        if (vm.tab == 2) {
          queries.push(
            orderBy("created_at", "desc"),
            where("post_status", "==", "draft")
          );
        }

        // Fetch posts for the "Deleted" tab
        if (vm.tab == 3) {
          queries.push(
            orderBy("created_at", "desc"),
            where("post_status", "==", "deleted")
          );
        }

        if (vm.startAfter) queries.push(startAfter(vm.startAfter));
        queries.push(limit(10));
        let q = query(col, ...queries);
        let docs = (await getDocs(q)).docs;

        let allPosts = docs.map((i) => {
          return {
            ...i.data(),
            id: i.id,
          };
        });

        vm.startAfter = docs[docs.length - 1];
        const allPlatforms = await vm.getAllPlatforms();

        allPosts.map((post) => {
          let socialMediaArr = [];
          const socialMedias = post.social_media;

          function filteredApp(name) {
            const item = allPlatforms.filter((data) => {
              return data.alias == name;
            });

            return item;
          }

          socialMedias.map((media) => {
            const filteredItem = filteredApp(media);

            let data = {
              name: media,
              label: filteredItem[0]?.name,
              logo_url: filteredItem[0]?.logo_url,
            };
            socialMediaArr.push(data);
          });

          post.social_media = socialMediaArr;
        });

        vm.posts = [...vm.posts, ...allPosts];
        if (allPosts.length == 10) {
          $state.loaded();
        } else {
          $state.complete();
        }

        vm.isLoading = false;
      } catch (error) {
        $state.complete();
        vm.handleError(error);
      }
    },

    async fetchDashboardStats() {
      // Check if cached data is valid
      const cachedData = localStorage.getItem("dashboardStats");
      const cachedTime = localStorage.getItem("dashboardStatsTime");

      if (cachedData && cachedTime) {
        const now = new Date().getTime();
        const timeDiff = now - parseInt(cachedTime);

        // If cache is still valid (less than cacheExpiry time)
        if (timeDiff < this.cacheExpiry) {
          this.dashboardStats = JSON.parse(cachedData);
          this.lastUpdated = new Date(parseInt(cachedTime));
          this.$nextTick(() => {
            this.renderCharts();
          });
          return;
        }
      }

      // If cache is not valid or doesn't exist, fetch fresh data
      await this.fetchFreshDashboardStats();
    },

    async fetchFreshDashboardStats() {
      if (this.isLoadingStats) return;

      const vm = this;
      let currentUID = this.currentUID || vm.uid;
      if (!vm.currentUID && !vm.WID) return;

      try {
        vm.isLoadingStats = true;

        const postsCollection = collection(
          colUsers,
          currentUID,
          "fly_workspaces",
          vm.WID,
          "social-posts"
        );

        // Get published posts count
        const publishedQuery = query(
          postsCollection,
          where("post_status", "==", "published")
        );
        const publishedSnapshot = await getCountFromServer(publishedQuery);
        vm.dashboardStats.publishedCount = publishedSnapshot.data().count;

        // Get scheduled posts count
        const currentDate = this.getCurrentDate();
        const scheduledQuery = query(
          postsCollection,
          where("scheduled_at", ">", currentDate),
          where("when_to_post", "==", "schedule")
        );
        const scheduledSnapshot = await getCountFromServer(scheduledQuery);
        vm.dashboardStats.scheduledCount = scheduledSnapshot.data().count;

        // Get draft posts count
        const draftQuery = query(
          postsCollection,
          where("post_status", "==", "draft")
        );
        const draftSnapshot = await getCountFromServer(draftQuery);
        vm.dashboardStats.draftCount = draftSnapshot.data().count;

        // Get deleted posts count
        const deletedQuery = query(
          postsCollection,
          where("post_status", "==", "deleted")
        );
        const deletedSnapshot = await getCountFromServer(deletedQuery);
        vm.dashboardStats.deletedCount = deletedSnapshot.data().count;

        // Calculate total count
        vm.dashboardStats.totalCount =
          vm.dashboardStats.publishedCount +
          vm.dashboardStats.scheduledCount +
          vm.dashboardStats.draftCount +
          vm.dashboardStats.deletedCount;

        // Get platform distribution data
        const allPostsQuery = query(postsCollection, limit(500));
        const allPostsSnapshot = await getDocs(allPostsQuery);
        const platformDistribution = {};
        const monthlyPosts = {};

        allPostsSnapshot.forEach((doc) => {
          const post = doc.data();

          // Count by platform
          if (post.social_media && Array.isArray(post.social_media)) {
            post.social_media.forEach((platform) => {
              const platformName =
                typeof platform === "string" ? platform : platform.name;
              if (platformName) {
                platformDistribution[platformName] =
                  (platformDistribution[platformName] || 0) + 1;
              }
            });
          }

          // Count by month
          if (post.created_at) {
            const postDate = new Date(post.created_at);
            const monthYear = moment(postDate).format("MMM YYYY");
            monthlyPosts[monthYear] = (monthlyPosts[monthYear] || 0) + 1;
          }
        });

        vm.dashboardStats.platformDistribution = platformDistribution;
        vm.dashboardStats.monthlyPosts = monthlyPosts;

        // Sort monthly data by date
        const sortedMonthlyPosts = {};
        Object.keys(monthlyPosts)
          .sort((a, b) => moment(a, "MMM YYYY").diff(moment(b, "MMM YYYY")))
          .forEach((key) => {
            sortedMonthlyPosts[key] = monthlyPosts[key];
          });

        vm.dashboardStats.monthlyPosts = sortedMonthlyPosts;

        // Update last updated time
        vm.lastUpdated = new Date();

        // Cache the data
        localStorage.setItem(
          "dashboardStats",
          JSON.stringify(vm.dashboardStats)
        );
        localStorage.setItem(
          "dashboardStatsTime",
          vm.lastUpdated.getTime().toString()
        );

        // Render charts
        vm.$nextTick(() => {
          vm.renderCharts();
        });

        vm.isLoadingStats = false;
      } catch (error) {
        console.error("Error fetching dashboard stats:", error);
        vm.isLoadingStats = false;
      }
    },

    refreshDashboardStats() {
      // Clear cache and fetch fresh data
      localStorage.removeItem("dashboardStats");
      localStorage.removeItem("dashboardStatsTime");
      this.fetchFreshDashboardStats();
    },

    renderCharts() {
      this.renderPlatformChart();
      this.renderMonthlyChart();
    },

    renderPlatformChart() {
      const platformData = this.dashboardStats.platformDistribution;
      this.hasPlatformData = Object.keys(platformData).length > 0;

      if (!this.hasPlatformData) return;

      const ctx = this.$refs.platformChart;
      if (!ctx) return;

      // Destroy existing chart if it exists
      if (this.platformChart) {
        this.platformChart.destroy();
      }

      const labels = Object.keys(platformData);
      const data = Object.values(platformData);

      // Generate colors for each platform
      const backgroundColors = [
        "#8056DE",
        "#3F51B5",
        "#4CAF50",
        "#FF9800",
        "#E91E63",
        "#009688",
        "#673AB7",
        "#FFC107",
        "#2196F3",
        "#795548",
      ];

      this.platformChart = new Chart(ctx, {
        type: "doughnut",
        data: {
          labels: labels,
          datasets: [
            {
              data: data,
              backgroundColor: backgroundColors.slice(0, labels.length),
              borderWidth: 1,
            },
          ],
        },
        options: {
          responsive: true,
          maintainAspectRatio: false,
          plugins: {
            legend: {
              position: "right",
              labels: {
                usePointStyle: true,
                padding: 20,
              },
            },
            tooltip: {
              callbacks: {
                label: function (context) {
                  const label = context.label || "";
                  const value = context.raw;
                  const total = context.dataset.data.reduce((a, b) => a + b, 0);
                  const percentage = Math.round((value / total) * 100);
                  return `${label}: ${value} (${percentage}%)`;
                },
              },
            },
          },
        },
      });
    },

    renderMonthlyChart() {
      const monthlyData = this.dashboardStats.monthlyPosts;
      this.hasMonthlyData = Object.keys(monthlyData).length > 0;

      if (!this.hasMonthlyData) return;

      const ctx = this.$refs.monthlyChart;
      if (!ctx) return;

      // Destroy existing chart if it exists
      if (this.monthlyChart) {
        this.monthlyChart.destroy();
      }

      const labels = Object.keys(monthlyData);
      const data = Object.values(monthlyData);

      this.monthlyChart = new Chart(ctx, {
        type: "bar",
        data: {
          labels: labels,
          datasets: [
            {
              label: "Posts",
              data: data,
              backgroundColor: "#8056DE",
              borderColor: "#6C44C8",
              borderWidth: 1,
            },
          ],
        },
        options: {
          responsive: true,
          maintainAspectRatio: false,
          scales: {
            y: {
              beginAtZero: true,
              ticks: {
                precision: 0,
              },
            },
          },
        },
      });
    },

    async getAllPlatforms() {
      if (this.allPlatforms.length != 0) return this.allPlatforms;
      const platformsRef = await getDocs(platforms);

      let allPlatforms = [];

      platformsRef.forEach((doc) => {
        allPlatforms.push(doc.data());
      });

      allPlatforms.sort((a, b) => a.display_priority - b.display_priority);

      this.socialAppLists = allPlatforms;

      return allPlatforms;
    },
    getCurrentDate() {
      return moment().utc().format("YYYY-MM-DDTHH:mm:ss.SSS[Z]");
    },
    formatDate(date) {
      return moment(date).format("MMM D, YYYY h:mm A");
    },
    hideZohoChat() {
      // if (typeof $zoho !== 'undefined' && typeof $zoho.salesiq !== 'undefined') {
      //   // Hide the Zoho Chat widget
      //   $zoho.salesiq.floatbutton.visible("hide");
      // }
      // setTimeout(() => $zoho.salesiq.floatbutton.visible("show"),60000)
    },
  },
  mounted() {
    this.hideZohoChat();
    if (this.tab === 0) {
      this.fetchDashboardStats();
    }
  },
};
</script>

<style scoped>
.tooltip {
  position: relative;
  display: inline-block;
  cursor: pointer;
}

.tooltip::before {
  content: attr(data-tooltip);
  position: absolute;
  bottom: 100%;
  left: 50%;
  transform: translateX(-50%);
  background-color: #333;
  color: #fff;
  padding: 5px 10px;
  border-radius: 5px;
  opacity: 0;
  transition: opacity 0.3s ease-in-out;
  white-space: nowrap;
  z-index: 1;
}

.tooltip:hover::before {
  opacity: 1;
}

.custom-tab {
  min-width: 0;
  /* Allow the tabs to shrink */
  padding: 8px 16px;
  /* Adjust the padding to make them smaller */
  white-space: nowrap;
  /* Prevent text from wrapping */
  text-overflow: ellipsis;
  /* Add ellipsis if the text overflows */
  overflow: hidden;
  /* Hide any overflow */
}

.rounded-btn {
  border-radius: 50%;
  position: fixed;
  bottom: 16px;
  right: 16px;
  /* width:50px;
  height: 50px; */
}

.onboarding-section {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 16px;
}

.onboarding-step {
  display: flex;
  align-items: center;
  margin-bottom: 8px;
}

.onboarding-step .number {
  width: 24px;
  /* Adjust the width to make the circle smaller */
  height: 24px;
  /* Adjust the height to make the circle smaller */
  border-radius: 50%;
  background-color: #2196f3;
  /* Blue color for the numbers */
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  /* Adjust the font size if needed */
  margin-right: 12px;
}

.onboarding-step span {
  font-size: 18px;
  margin-right: 12px;
  /* Add margin to create space between the circle and text */
}
</style>
